<template>
    <div>
        <b-modal title="Fulfillments"
                 size="xl"
                 centered
                 no-close-on-backdrop
                 v-model="dialogOpen"
                 @hidden="onDialogHidden">
            <ul class="list-group list-group-flush" v-if="!externalSourceFulfillments || !externalSourceFulfillments.length">
                <li class="list-group-item">
                    The list is currently empty
                </li>
            </ul>
            <b-table id="externalSourceFulfillmentsTable" striped hover :items="externalSourceFulfillments" :fields="tableFields" :current-page="currentPage" :per-page="perPage" v-if="externalSourceFulfillments && externalSourceFulfillments.length">
                
            </b-table>
            <b-pagination v-model="currentPage"
                          :total-rows="externalSourceFulfillments.length"
                          :per-page="perPage"
                          size="sm"
                          align="right"
                          aria-controls="externalSourceFulfillmentsTable"
                          v-if="(externalSourceFulfillments != null) && (externalSourceFulfillments.length > 0)">
            </b-pagination>

            <template v-slot:modal-footer="{ cancel }">
                <b-button @click="cancel">Close</b-button>
                <b-button variant="primary" @click="openRequestFulfillmentDialog" v-if="!readonly">Request</b-button>
            </template>
        </b-modal>

        <b-modal v-model="fulfillmentDetailsDialogOpen"
                 title="Fulfillment Options"
                 @ok="requestFulfillment"
                 @cancel="fulfillmentDetailsDialogOpen=false"
                 ok-title="Request"
                 cancel-title="Cancel">

            <b-form-group label="Delivery Formats">
                <select2 name="deliveryFormats"
                         v-model="fulfillmentDetails.deliveryFormats"
                         :options="deliveryFormatOptions"
                         multiple
                         allow-clear
                         in-b-modal></select2>
            </b-form-group>

            <b-form-group>
                <b-form-checkbox v-model="fulfillmentDetails.isReplacement" switch>
                    Replacement
                </b-form-checkbox>
                <b-form-checkbox v-model="fulfillmentDetails.isEndOfDay" switch disabled>
                    End of Day
                </b-form-checkbox>
                <b-form-checkbox v-model="fulfillmentDetails.isOrderComplete" switch>
                    Order Complete
                </b-form-checkbox>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
    //import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import Select2 from '../Select2';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'ExternalSourceFulfillmentsDialog',
        mixins: [ErrorsMixin, DateTimeMixin],
        components: {
            'select2': Select2
        },
        model: {
            event: 'change',
            prop: 'active'
        },
        props: {
            transcriptWorkItemId: {
                type: String,
                required: true
            },
            readonly: {
                type: Boolean,
                default: false
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                externalSourceFulfillments: null,
                dialogOpen: this.active,
                tableFields: [
                    {
                        key: 'pageNumbers',
                        label: 'Pages',
                        class: 'fit'
                    },
                    {
                        key: 'timeRange',
                        label: 'Times',
                        class: 'fit'
                    },
                    {
                        key: 'deliveryFormat',
                        label: 'Format',
                        class: 'fit'
                    },
                    {
                        key: 'requestedDateTimeUTC',
                        label: 'Requested',
                        formatter: value => {
                            return this.formatDateTime(value, 'DD/MM/YYYY hh:mma', false);
                        },
                        class: 'fit'
                    },
                    {
                        key: 'requestedByUserDisplayName',
                        label: 'Requested By',
                        class: 'fit'
                    },
                    {
                        key: 'submittedDateTimeUTC',
                        label: 'Submitted',
                        formatter: (value, key, item) => {
                            if (item.receiptDateTimeUTC) return this.formatDateTime(value, 'DD/MM hh:mma', false);
                            return this.formatDateTime(value, 'DD/MM hh:mma', false);
                        },
                        class: 'fit'
                    },
                    {
                        key: 'receiptNumber',
                        label: 'Number'
                    },
                    {
                        key: 'fulfillmentStatus',
                        label: 'Status',
                        formatter: (value, key, item) => {
                            return this.fulfillmentStatusText(item);
                        },
                    }
                ],
                currentPage: 1,
                perPage: 10,

                fulfillmentDetailsDialogOpen: false,
                fulfillmentDetails: {
                    deliveryFormats: [],
                    isReplacement: false,
                    isEndOfDay: true,
                    isOrderComplete: false
                },
                deliveryFormatOptions: [
                    {
                        value: this.$enum.DeliveryFormat.MSWord,
                        text: this.$enum.DeliveryFormat.$displayNames.MSWord
                    },
                    {
                        value: this.$enum.DeliveryFormat.XML,
                        text: this.$enum.DeliveryFormat.$displayNames.XML
                    },
                    {
                        value: this.$enum.DeliveryFormat.Text,
                        text: this.$enum.DeliveryFormat.$displayNames.Text
                    },
                    {
                        value: this.$enum.DeliveryFormat.PDF,
                        text: this.$enum.DeliveryFormat.$displayNames.PDF
                    },
                    //{
                    //    value: this.$enum.DeliveryFormat.HardCopy,
                    //    text: this.$enum.DeliveryFormat.$displayNames.HardCopy
                    //}
                ]
            }
        },
        watch: {
            active: function () {
                if (this.active) {
                    this.reload();
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {
            reload: function () {
                var url = this.$urlHelper.getApiUrl('ExternalSourceFulfillment', 'getList', [this.transcriptWorkItemId])
                return axios
                    .get(url)
                    .then(response => {
                        this.externalSourceFulfillments = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            this.showErrorsToast(currentErrors);
                        }
                    });
            },
            fulfillmentStatusText: function (externalSourceFulfillment) {
                if (externalSourceFulfillment.submittedDateTimeUTC) {
                    if (externalSourceFulfillment.success === true) return "Succeeded";
                    if (externalSourceFulfillment.success === false) return "Failed";
                }
                return "Pending";
            },
            
            openRequestFulfillmentDialog: function () {
                this.fulfillmentDetails.deliveryFormats = [this.$enum.DeliveryFormat.MSWord, this.$enum.DeliveryFormat.XML, this.$enum.DeliveryFormat.PDF/*, this.$enum.DeliveryFormat.HardCopy*/]
                this.fulfillmentDetails.isReplacement = false;
                this.fulfillmentDetails.isEndOfDay = true;
                this.fulfillmentDetails.isOrderComplete = false;
                this.fulfillmentDetailsDialogOpen = true;
            },

            requestFulfillment: function () {
                var data = {
                    deliveryFormats: this.fulfillmentDetails.deliveryFormats,
                    isReplacement: this.fulfillmentDetails.isReplacement,
                    isEndOfDay: this.fulfillmentDetails.isEndOfDay,
                    isOrderComplete: this.fulfillmentDetails.isOrderComplete
                }
                var url = this.$urlHelper.getApiUrl('ExternalSourceFulfillment', 'request', [this.transcriptWorkItemId]);

                axios
                    .post(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.$bvToast.toast('Fulfillment requested successfully', {
                            title: 'Fulfillment Requested',
                            variant: 'success',
                            appendToast: true
                        });
                        this.fulfillmentDetailsDialogOpen = false;
                        this.reload();
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        if (currentErrors.length != 0) {
                            this.showErrorsToast(currentErrors);
                        }
                    });
            },

            onDialogHidden: function () {
                this.$emit('change', false);
            },
        }
    }
</script>

